__webpack_require__.p = "/mbs-ui/";